<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <StatusBar :params="this.$route.query.params" />

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <CardStyle @changeStyle="changeStyle" />
    </div>

    <!-- 查詢列 -->
    <SearchBar
      :show="showSearchBar"
      @showSearchBar="showSearchBar = !showSearchBar"
      @search="
        (currentPage = 1),
          getDeclineInterview()
      "
    >
      <template v-slot:searchItem>
        <el-input
          class="w-100 item-bottom"
          clearable
          placeholder="關鍵字（姓名、Email、聯絡電話）"
          v-model.trim="searchCondition.Keyword"
        />
        <el-date-picker
          class="w-100 item-bottom"
          type="daterange"
          clearable
          :picker-options="{
            disabledDate: $common.disabledDateAfterToday,
          }"
          range-separator="-"
          start-placeholder="面談日期(起)"
          end-placeholder="面談日期(迄)"
          v-model="searchCondition.InterviewDateRange"
        />
      </template>
    </SearchBar>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        class="person-card"
        v-for="(person, index) in personList"
        :key="index"
      >
        <PersonCard ref="personCard" :showCheckbox="false" :person="person">
          <template v-slot:note="{ props }">
            <button type="button" @click="clickResumeNote(props)">
              <eva-icon name="color-picker-outline" fill="#000" />
            </button>
          </template>

          <template v-slot:tag="{ props }">
            <div class="result">{{ props.ApprovalResult }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>面談時間</th>
                <td>{{ $common.dateFormatter(props.InterviewDate) }}</td>
              </tr>
              <tr>
                <th>未到原因</th>
                <td>
                  {{ props.NotArrivedReason }}
                </td>
              </tr>
            </table>
          </template>
          <template v-slot:buttonGroup="{ props }">
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                檢視資訊<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetailModal(props)">
                  檢視履歷
                </el-dropdown-item>
                <el-dropdown-item @click.native="showProgressRecord(props)">
                  檢視歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button type="button" @click="clickReinvite(props)">
              重新邀約
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 檢視資訊 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <!-- 檢視歷程 -->
    <ProgressRecordModal :Name="Name" :UserId="UserId" :Email="Email" />

    <!-- 履歷 Note -->
    <ResumeNoteModal :personData="interviewee" />

    <!-- 重新邀約 -->
    <ReinviteMailModal :personData="interviewee" @updatePerson="updatePerson" />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 招募狀態列表
import StatusBar from "@/components/back/OpeningManage/StatusBar";
// 公司Logo
import Logo from "@/components/company/Logo.vue";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 歷程
import ProgressRecordModal from "@/views/back/TalentQuery/ResultPage/Modal/ProgressRecord";
// 查詢列
import SearchBar from "@/components/back/ToolBar/SearchBar";
// 重新邀約
import ReinviteMailModal from "@/components/back/Modal/ReinviteMail";
// 履歷 Note
import ResumeNoteModal from "@/components/back/Modal/ResumeNote";

export default {
  name: "DeclineInterview",

  props: {
    did: { // 需求單號
      type: String,
    }
  },

  components: {
    StatusBar,
    Logo,
    CardStyle,
    PersonCard,
    IdlResume,
    DlResume,
    ProgressRecordModal,
    SearchBar,
    ReinviteMailModal,
    ResumeNoteModal,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // data
      personList: [],
      interviewee: {},

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類

      // 檢視歷程
      Name: null,
      UserId: null,
      Email: null,

      // 查詢列
      showSearchBar: false,
      searchCondition: {},

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁
    };
  },

  methods: {
    // 取得 面談未到
    getDeclineInterview() {
      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.jobManagement
        .getDeclineInterviewPaging(
          {
            Keyword: this.searchCondition.Keyword,
            interviewDateStart: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[0]
                )
              : null,
            interviewDateEnd: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[1]
                )
              : null,
            Page: this.currentPage,
            PerPage: 9,
          },
          this.did
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              this.totalPerson = response.data.Quantity;
              this.personList = response.data.Datas;
              this.$store.commit("ScrollTop", false);
            }
          }
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getDeclineInterview();
    },

    // 履歷 Note
    clickResumeNote(person) {
      this.interviewee = person;
      this.$store.dispatch("getResumeSummary", person.MatchId);
      this.$store.commit("OpenResumeNoteModal", true);
    },

    // 檢視資訊 Modal
    showDetailModal(item) {
      this.MatchId = item.MatchId;
      this.ResumeId = item.ResumeId;
      this.ResumeType = item.ResumeType;
      this.isShowDetail = true;
    },

    // 檢視歷程
    showProgressRecord(person) {
      this.MatchId = person.Id;
      this.Name = person.Name;
      this.UserId = person.UserId;
      this.Email = person.Email;
      this.$store.commit("OpenCandidateProcessModal", true);
    },

    // 重新邀約
    clickReinvite(person) {
      this.interviewee = person;
      this.$store.commit("OpenReinviteMailModal", true);
    },

    // 更新卡片
    updatePerson() {
      this.currentPage = 1;
      this.getDeclineInterview();
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getDeclineInterview();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input {
  display: block;
}

/deep/ .el-select {
  display: block;
}
</style>
